module.exports = __webpack_public_path__ + "img/logo.39dd1cc1.png";